/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.groups', [
    'ngRoute',
    'ui.grid',
    'ui.grid.selection',
    'prism-ui.components.navigation',
    'prism-ui.components.data',
    'prism-ui.components.filters'
])
.constant('X2JS', window.X2JS)
.value('PERMISSION_EXCEPTION_LIST', {
    PACKAGE_VIEW_DOWNLOAD_PROXY_VIEW_STATE: {
        displayName: 'Packages - View/Download Proxies',
        includeOffset: true
    },
    PACKAGE_APPROVE_REJECT_VIEW_STATE: {
        displayName: 'Packages - Approve/Reject',
        includeOffset: false
    },
    PACKAGE_RESTORE_MASTER_MEDIA_VIEW_STATE: {
        displayName: 'Packages - Restore Master Media',
        includeOffset: true
    },
    CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE: {
        displayName: 'Clips - Retrieve Master Clip Media',
        includeOffset: true
    },
    CLIP_ACTION_VIEW_PROXIES_VIEW_STATE: {
        displayName: 'Clips - View Clip Proxies',
        includeOffset: true
    },
    CLIP_ACTION_DOWNLOAD_PROXIES_VIEW_STATE: {
        displayName: 'Clips - Download Clip Proxies',
        includeOffset: true
    }
})
.value('APPLICATION_STATE_LIST', {
    packages: {
        parentViewStates: {
            PACKAGE_VIEW_STATE: 'Package'
        },
        childViewStates: {
            packageAction: {
                PACKAGE_SEARCH_VIEW_STATE: 'Packages - Create',
                PACKAGE_DELIVER_VIEW_STATE: 'Packages - Execute/Deliver',
                PACKAGE_MANAGER_DELIVER_VIEW_STATE: 'Packages - Batch Execute/Deliver',
                PACKAGE_SELECT_DELIVERY_CONTENT_VIEW_STATE: 'Packages - Select Package Content',
                PACKAGE_VIEW_DOWNLOAD_PROXY_VIEW_STATE: 'Packages - View/Download Proxies',
                PACKAGE_RECREATE_PROXY_VIEW_STATE: 'Packages - Recreate Proxies',
                PACKAGE_APPROVE_REJECT_VIEW_STATE: 'Packages - Approve/Reject',
                PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE: 'Packages - Ad-Hoc Add Partners',
                PACKAGE_RESTORE_MASTER_MEDIA_VIEW_STATE: 'Packages - Restore Master Media',
                PACKAGE_CLONE_VIEW_STATE: 'Packages - Clone a Package',
                PACKAGE_BATCH_CLONE_VIEW_STATE: 'Packages - Batch Clone Packages',
                PACKAGE_ORD_VIEW_STATE: 'Packages - ORD for Non-Delivered',
                PACKAGE_CREATE_COLLABORATOR_VIEW_STATE: 'Packages - Create Collaborator',
                PACKAGE_BRANDING_VIEW_STATE: 'Packages - Branding'
            },
            packageBasic: {
                PACKAGE_METADATA_VIEW_STATE: 'Package Metadata',
                PACKAGE_COLLABORATORS_VIEW_STATE: 'Package Collaborators',
                PACKAGE_MEDIA_VIEW_STATE: 'Package Media',
                PACKAGE_DISTRIBUTIONGRID_VIEW_STATE: 'Package Distribution',
                ADVANCED_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE: 'Package Advanced Distribution',
                PACKAGE_VIDEO_PREVIEW_VIEW_STATE: 'Package Video Preview',
                PACKAGE_VIDEO_CLIPS_VIEW_STATE: 'Package Video Clips',
                PACKAGE_TIMINGS_VIEW_STATE: 'Package Timings',
                PACKAGE_ADVANCED_METADATA_VIEW_STATE: 'Package Advanced Metadata',
                PACKAGE_COMPLETED_DELIVERIES_VIEW_STATE: 'Package Completed Deliveries',
                PACKAGE_EXTERNAL_INGESTS_VIEW_STATE: 'Package Aggregation'
            },
            packageActionClip: {
                CLIP_ACTION_RESET_VIEW_STATE: 'Clips - Reset',
                CLIP_ACTION_DELIVER_VIEW_STATE: 'Clips - Execute/Deliver',
                CLIP_ACTION_RE_EXTRACT_VIEW_STATE: 'Clips - Re-Extract',
                CLIP_ACTION_VALIDATE_VIEW_STATE: 'Clips - Validate',
                CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE: 'Clips - Retrieve Master Clip Media',
                CLIP_ACTION_HIDE_VIEW_STATE: 'Clips - Hide/Show Hidden',
                CLIP_ACTION_VIEW_PROXIES_VIEW_STATE: 'Clips - View Clip Proxies',
                CLIP_ACTION_DOWNLOAD_PROXIES_VIEW_STATE: 'Clips - Download Clip Proxies',
                CLIP_ACTION_EXPORT_METADATA_VIEW_STATE: 'Clips - Export Metadata',
                CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE: 'Clips - Generate Delivery Report',
                CLIP_ACTION_BRANDING_VIEW_STATE: 'Clips - Branding'
            },
            packageClip: {
                CLIP_COLLABORATORS_VIEW_STATE: 'Clips - Collaborators',
                CLIP_DISTRIBUTIONGRID_VIEW_STATE: 'Clips - Distribution Grid',
                ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE: 'Clips - Advanced Distribution Grid'
            }
        }
    },
    dashboard: {
        parentViewStates: {
            DASHBOARD_WORKFLOW_VIEW: 'Workflows',
            DASHBOARD_QUEUE_VIEW: 'Queues',
            DASHBOARD_REPORT_VIEW_STATE: 'Reports',
            DASHBOARD_CALENDAR_VIEW_STATE: 'Calendars',
            DASHBOARD_OFF_CYCLE_PLANNERS_VIEW_STATE: 'Off-Cycle Planners'
        }
    },
    meta: {
        parentViewStates: {
            NETWORK_VIEW_STATE: 'Networks',
            ADS_VIEW_STATE: 'Ads/PreRolls',
            SERIES_VIEW_STATE: 'Series',
            MOVIE_VIEW_STATE: 'Movies/Specials',
            COLLABORATOR_VIEW_STATE: 'Collaborators',
            MVPD_VIEW_STATE: 'MVPD Setup'
        },
        childViewStates: {
            metaNetwork: {
                NETWORK_PREROLL_SEARCH_VIEW_STATE: 'Preroll',
                NETWORK_POSTROLL_SEARCH_VIEW_STATE: 'Postroll',
                NETWORK_WATERMARK_SEARCH_VIEW_STATE: 'Watermark',
                NETWORK_ARTWORK_SEARCH_VIEW_STATE: 'Artwork'
            },
            metaSeries: {
                SERIES_PREROLL_SEARCH_VIEW_STATE: 'Preroll',
                SERIES_POSTROLL_SEARCH_VIEW_STATE: 'Postroll',
                SERIES_WATERMARK_SEARCH_VIEW_STATE: 'Watermark',
                SERIES_ARTWORK_SEARCH_VIEW_STATE: 'Artwork'
            },
            metaMovie: {
                MOVIE_PREROLL_SEARCH_VIEW_STATE: 'Preroll',
                MOVIE_POSTROLL_SEARCH_VIEW_STATE: 'Postroll',
                MOVIE_WATERMARK_SEARCH_VIEW_STATE: 'Watermark',
                MOVIE_ARTWORK_SEARCH_VIEW_STATE: 'Artwork'
            }
        }
    },
    system: {
        parentViewStates: {
            SYSTEM_PARTNERS_VIEW_STATE: 'Partners'
        },
        childViewStates: {
            systemPartner: {
                SYSTEM_PARTNERS_DELIVERYENDPOINTS_VIEW_STATE: 'Delivery Endpoints',
                SYSTEM_PARTNERS_EMAIL_VIEW_STATE: 'Email Endpoints',
                SYSTEM_PARTNERS_DELIVERYPROFILES_VIEW_STATE: 'Delivery Profiles',
                SYSTEM_PARTNERS_DUE_DATE_TEMPLATES_VIEW_STATE: 'SLA Templates',
                SYSTEM_PARTNERS_NIELSEN_TEMPLATES_VIEW_STATE: 'Nielsen Templates',
                SYSTEM_PARTNERS_SETUPGUIDES_VIEW_STATE: 'Setup Guides'
            }
        }
    },
    systemOps: {
        parentViewStates: {
            DEBUG_SYSTEM_OPERATIONS_VIEW_STATE: 'Debug - System Operations'
        },
        childViewStates: {
            impliedSystemOps: {
                PACKAGE_BATCH_MODIFY_METADATA_VIEW_STATE: 'Packages - Batch Modify Metadata',
                CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE: 'Clips - Batch Modify Metadata'
            }
        }
    }
});
